const toIsoDate = (date) => {
	const day = String(date.getDate()).padStart(2, "0");
	const month = String(date.getMonth() + 1).padStart(2, "0");
	const year = date.getFullYear();
	return `${year}-${month}-${day}`;
};

const startOfDay = (date) => {
	const next = new Date(date);
	next.setHours(0, 0, 0, 0);
	return next;
};

const endOfDay = (date) => {
	const next = new Date(date);
	next.setHours(23, 59, 59, 999);
	return next;
};

const startOfWeek = (date) => {
	const next = startOfDay(date);
	const day = next.getDay();
	const diff = day === 0 ? 6 : day - 1;
	next.setDate(next.getDate() - diff);
	return next;
};

const endOfWeek = (date) => {
	const next = startOfWeek(date);
	next.setDate(next.getDate() + 6);
	return endOfDay(next);
};

export const DATE_RANGE_OPTIONS = [
	{ key: "today", label: "Today" },
	{ key: "thisWeek", label: "This Week" },
	{ key: "lastWeek", label: "Last Week" },
	{ key: "thisMonth", label: "This Month" },
	{ key: "lastMonth", label: "Last Month" },
	{ key: "custom", label: "Custom" },
];

export const DEFAULT_DATE_RANGE_KEY = "thisMonth";

export const getDateRangeForPreset = (presetKey, customStart, customEnd) => {
	const now = new Date();

	if (presetKey === "today") {
		return {
			endDate: toIsoDate(now),
			label: "Today",
			startDate: toIsoDate(now),
		};
	}

	if (presetKey === "thisWeek") {
		return {
			endDate: toIsoDate(endOfWeek(now)),
			label: "This Week",
			startDate: toIsoDate(startOfWeek(now)),
		};
	}

	if (presetKey === "lastWeek") {
		const lastWeekAnchor = new Date(now);
		lastWeekAnchor.setDate(lastWeekAnchor.getDate() - 7);
		return {
			endDate: toIsoDate(endOfWeek(lastWeekAnchor)),
			label: "Last Week",
			startDate: toIsoDate(startOfWeek(lastWeekAnchor)),
		};
	}

	if (presetKey === "lastMonth") {
		const start = new Date(now.getFullYear(), now.getMonth() - 1, 1);
		const end = new Date(now.getFullYear(), now.getMonth(), 0);
		return {
			endDate: toIsoDate(end),
			label: "Last Month",
			startDate: toIsoDate(start),
		};
	}

	if (presetKey === "custom") {
		if (customStart && customEnd) {
			const start = startOfDay(new Date(`${customStart}T00:00:00`));
			const end = endOfDay(new Date(`${customEnd}T00:00:00`));
			return {
				endDate: toIsoDate(end),
				label: "Custom",
				startDate: toIsoDate(start),
			};
		}
		return {
			endDate: null,
			label: "Custom",
			startDate: null,
		};
	}

	const monthStart = new Date(now.getFullYear(), now.getMonth(), 1);
	return {
		endDate: toIsoDate(now),
		label: "This Month",
		startDate: toIsoDate(monthStart),
	};
};

export const formatShortMonthDay = (value) => {
	if (!value) return null;
	const date = new Date(value);
	if (Number.isNaN(date.getTime())) return null;
	return date.toLocaleDateString("en-US", { day: "numeric", month: "short" });
};
